<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';

const props = defineProps<{
	class?: HTMLAttributes['class'];
}>();
</script>

<template>
	<div :class="cn('p-7 px-9 pb-6 pt-0 leading-6 tracking-wide', props.class)">
		<slot></slot>
	</div>
</template>
